<div class="card mx-auto" style="max-width: 400px;">
    <div class="card-body playwrite-au-nsw">
      <h4>Forgot Username/Password</h4>
      <div class="mb-3">
        <label>Email</label>
        <input [(ngModel)]="email" name="email" class="form-control" type="email" />
      </div>
      <button class="btn btn-primary" (click)="onSendCode()">Send Recovery Code</button>
    </div>
  </div>